module.exports = __webpack_public_path__ + "img/delete.088431e2.png";